"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.join");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _invariant = _interopRequireDefault(require("invariant"));

/**
 * Vrati query part pre vyhladavanie textu bez diakritiky v plnej zhode (tak ako je zadany) v multilang fieldoch.
 *
 * Napriklad:
 * 'aáaa' =$match=> 'aaaa'
 * 'aáaa' =! $match=> 'aaaaaa'
 * 'aáaa aaa' =$match=> 'aaaa aaa'
 * 'aáaa aaa' =! $match=> 'aaaa aaaa'
 *
 * @param {string} fieldName
 * @param {string} value
 *
 * @returns {Object}
 */
var textElementMatchToQuery = function textElementMatchToQuery(fieldName, value) {
  var parts = fieldName.split('.');
  (0, _invariant.default)(parts.length > 1, "At least one sub field have to be defined. If you don't have sub fields to match, please consider to use 'textMatchToQuery'.");
  var innerField = parts.pop();
  return value === undefined ? undefined : (0, _defineProperty2.default)({}, parts.join('.'), {
    $elemMatch: (0, _defineProperty2.default)({}, innerField, {
      $match: value
    })
  });
};

var _default = textElementMatchToQuery;
exports.default = _default;